import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { Modal } from 'bootstrap';
import { Data2Service } from '../data2.service';
import { DateService } from '../date.service';
import { UuidService } from '../uuid.service';
import { AuthService } from '../../auth/auth.service';
import { QuestionService } from '../question-dialog/question-dialog.service';
import { InfoboxService } from '../infobox/infobox.service';

@Component({
	selector: 'app-php-tasks',
	templateUrl: './php-tasks.component.html',
	styleUrls: ['./php-tasks.component.css'],
})
export class PhpTasksComponent implements OnInit, OnChanges {
	@Input() objType: number;
	@Input() objId: number;
	private itemsBeforeDataLoad = 3;
	tasks = {
		active: null,
		completed: null,
	};
	task = {
		id: null,
		objType: null,
		objId: null,
		type: null,
		status: null,
		author: null,
		owners: null,
		deadline: null,
		content: null,
	};
	errors = {
		type: null,
		owners: null,
		deadline: null,
		content: null,
	};
	deadline = {
		date: null,
		time: null,
	};
	types: Array<any> = [];
	users: Array<any> = [];
	questionSubscription;

	constructor(
		private readonly api: Data2Service,
		private readonly date: DateService,
		private readonly uuid: UuidService,
		private readonly auth: AuthService,
		private readonly question: QuestionService,
		private readonly infobox: InfoboxService,
	) {}

	ngOnInit(): void {
		const date = this.date.now();
		this.deadline.date = date.date;
		this.deadline.time = date.time;
		this.task.owners = [this.auth.getUserId()];
		this.api.get('/tasksTypes/', (result, error) => {
			this.types = result.data;
			this.loadData();
		});
		this.api.get('/users/', (result, error) => {
			this.users = result.data;
			this.loadData();
		});
	}

	ngOnChanges(): void {
		if (this.objType === undefined || this.objId === undefined) {
			return;
		}
		this.task.objType = this.objType;
		this.task.objId = this.objId;
		this.loadData();
	}

	private loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/tasks/?objType=' + this.objType + '&objId=' + this.objId, (result, error) => {
			result.data.forEach((obj) => {
				const type = this.types.find((findObj) => findObj.id == obj.type);
				obj.ownersName = this.find(obj.owners);
				obj.authorName = this.find(obj.author);
				obj.color = type ? '#' + type.color : '#000000';
				obj.typeName = type ? type.name : '?';
			});
			this.tasks.active = result.data.filter((obj) => obj.status == '1');
			this.tasks.completed = result.data.filter((obj) => obj.status == '2');
		});
	}

	private find(obj) {
		const find = this.users.find((objFind) => objFind.id == obj);
		return find ? find.name : '?';
	}

	submit(): void {
		this.task.id = this.uuid.generate();
		this.task.deadline = this.date.combine(this.deadline.date, this.deadline.time);
		let hasErrors = false;
		for (const key in this.errors) {
			if (!this.task[key]) {
				this.errors[key] = true;
				hasErrors = true;
				continue;
			}
			this.errors[key] = false;
		}
		if (hasErrors) {
			return;
		}
		this.api.post('/tasks/', this.task, (result, error) => {
			if (error) {
				alert('error - check console');
				return;
			}
			this.loadData();
			this.task.owners = [this.auth.getUserId()];
			this.task.content = null;
			this.task.type = null;
		});
	}

	askAction(action: string, taskId: string): void {
		switch (action) {
			case '2':
				this.question.ask('Czy na pewno zakończyć?', 'questionAsk');
				break;
			case '1':
				this.question.ask('Czy na pewno przywrócić?', 'questionAsk');
				break;
		}
		this.questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'questionAsk') {
				return;
			}
			if (!result.result) {
				return;
			}
			this.questionSubscription.unsubscribe();
			this.changeStatus(action, taskId);
		});
	}

	changeStatus(action: string, taskId: string): void {
		let task = this.tasks.active.find((obj) => obj.id == taskId);
		if (!task) {
			task = this.tasks.completed.find((obj) => obj.id == taskId);
		}
		if (!task) {
			this.infobox.error('Task not found!');
			return;
		}
		task.status = action;
		if (!taskId) {
			return;
		}
		this.api.put('/tasks/' + taskId, task, (result, error) => {
			if (error) {
				return;
			}
			this.loadData();
		});
	}
}
